import { render, staticRenderFns } from "./SimpleDocument.vue?vue&type=template&id=9318345a&"
import script from "./SimpleDocument.vue?vue&type=script&lang=js&"
export * from "./SimpleDocument.vue?vue&type=script&lang=js&"
import style0 from "./SimpleDocument.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SimpleDocument.vue"
export default component.exports